import React, { Component } from 'react';
import Script from 'react-load-script';
import './ScriptsLoader.css';
import { inject, observer } from 'mobx-react';

const MAPJS_BASEURL = 'https://js.api.here.com/v3/3.1';

@inject('scriptsLoaderStore')
@observer
export default class ScriptsLoader extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  handleScriptCreate = filename => () => {
    let newState = Object.assign({}, this.state);
    newState[filename] = 'created';
    this.setState(newState);
  };
  handleScriptError = filename => () => {
    let newState = Object.assign({}, this.state);
    newState[filename] = 'error';
    this.setState(newState);
  };
  handleScriptLoad = filename => () => {
    let newState = Object.assign({}, this.state);
    newState[filename] = 'loaded';
    this.setState(newState);
    this.props.scriptsLoaderStore.load(filename);
  };

  isLoaded = filename => this.state[filename] === 'loaded';

  render() {
    return (
      <div className="ScriptsLoader">
        <Script
          url={`${MAPJS_BASEURL}/mapsjs-core.js`}
          onCreate={this.handleScriptCreate('mapsjs-core.js')}
          onError={this.handleScriptError('mapsjs-core.js')}
          onLoad={this.handleScriptLoad('mapsjs-core.js')}
        />

        {this.isLoaded('mapsjs-core.js') && (
          <Script
            url={`${MAPJS_BASEURL}/mapsjs-core-legacy.js`}
            onCreate={this.handleScriptCreate('mapsjs-core-legacy.js')}
            onError={this.handleScriptError('mapsjs-core-legacy.js')}
            onLoad={this.handleScriptLoad('mapsjs-core-legacy.js')}
          />
        )}

        {this.isLoaded('mapsjs-core.js') && (
          <Script
            url={`${MAPJS_BASEURL}/mapsjs-service.js`}
            onCreate={this.handleScriptCreate('mapsjs-service.js')}
            onError={this.handleScriptError('mapsjs-service.js')}
            onLoad={this.handleScriptLoad('mapsjs-service.js')}
          />
        )}

        {this.isLoaded('mapsjs-service.js') && (
          <Script
            url={`${MAPJS_BASEURL}/mapsjs-service-legacy.js`}
            onCreate={this.handleScriptCreate('mapsjs-service-legacy.js')}
            onError={this.handleScriptError('mapsjs-service-legacy.js')}
            onLoad={this.handleScriptLoad('mapsjs-service-legacy.js')}
          />
        )}

        {this.isLoaded('mapsjs-core.js') && (
          <Script
            url={`${MAPJS_BASEURL}/mapsjs-ui.js`}
            onCreate={this.handleScriptCreate('mapsjs-ui.js')}
            onError={this.handleScriptError('mapsjs-ui.js')}
            onLoad={this.handleScriptLoad('mapsjs-ui.js')}
          />
        )}

        {this.isLoaded('mapsjs-ui.js') && this.isLoaded('mapsjs-service.js') && (
          <Script
            url={`${MAPJS_BASEURL}/mapsjs-mapevents.js`}
            onCreate={this.handleScriptCreate('mapsjs-mapevents.js')}
            onError={this.handleScriptError('mapsjs-mapevents.js')}
            onLoad={this.handleScriptLoad('mapsjs-mapevents.js')}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/ScriptsLoader/ScriptsLoader.js